module.exports = __webpack_public_path__ + "b48170feee907a2915a49daeef8d36a2.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/ALLEYESONUS2.jpg
// module id = 738
// module chunks = 0